import { basicSettings } from './basicSettings';

const FONT_PRIMARY =
  "'FSSiena-Regular','Source_Sans_Pro-Regular','Roboto-Regular',Arial,Verdana,Sans Serif";
// "'Suisse-Intl','Source_Sans_Pro-Regular','Roboto-Regular',Arial,Verdana,Sans Serif";

const typography = {
  fontFamily: FONT_PRIMARY,
  fontWeightRegular: 400,
  fontWeightBold: 600,
};

Object.entries(basicSettings).map(([key, value]) => {
  typography[key] = {
    fontWeight: 400,
    ...value,
  };
  typography[`${key}-bold`] = {
    fontWeight: 600,
    fontFamily: 'FSSiena-Regular',
    ...value,
  };
});

export default typography;
